import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component RobotIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <RobotIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <RobotIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const RobotIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="RobotIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M9 11a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1M15 11a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1" />
      <path
        fillRule="evenodd"
        d="M11.353 2.237a1 1 0 0 1 .81-.223l3 .5a1 1 0 0 1-.327 1.972L13 4.18V6h5c1.73 0 3 1.495 3 3.167v3.215l.552-.277a1 1 0 0 1 .895 1.79L21 14.618v3.215C21 19.505 19.73 21 18 21H6c-1.73 0-3-1.495-3-3.167v-3.215l-1.448-.723a1 1 0 0 1 .895-1.79l.553.277V9.167C3 7.495 4.27 6 6 6h5V3a1 1 0 0 1 .353-.763M6 8c-.479 0-1 .446-1 1.167v8.666C5 18.554 5.52 19 6 19h12c.478 0 1-.446 1-1.167V9.167C19 8.446 18.478 8 18 8z"
        clipRule="evenodd"
      />
    </svg>
  )
);
RobotIcon.displayName = "RobotIcon";
export default RobotIcon;
